<template>
    <div>
        <dx-grid
            class="routes"
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onCellClicked="onCellClicked"
            navigationPath="onCellClicked"
            navigationField="onCellClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
            :summaryOptions="{
                enabled: true,
                isNumber: true,
                columns: [
                    'families',
                    'boxes',
                    'scannedBoxes',
                    'unScannedBoxes',
                    'largeBoxes',
                    'delivered',
                    'unDelivered',
                    'smallBoxes',
                ],
            }"
        ></dx-grid>
        <v-card
            class="mt-0 mb-0 mx-4 pa-3 py-2"
            v-if="loadingMissing || missingBoxes.length"
        >
            <v-progress-linear
                v-if="loadingMissing"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <vue-good-table
                v-if="missingBoxes.length"
                class="missing-boxes-list"
                style="width: 100%;"
                styleClass="vgt-table striped"
                :columns="missingBoxesColumns"
                :rows="missingBoxes"
                :search-options="{
                    enabled: false,
                }"
                :expandedOptions="{
                    enabled: true,
                    template: 'missing-boxes',
                }"
            >
                <template
                    slot="table-column"
                    slot-scope="props"
                    class="text-xs-left"
                >
                    <span
                        class="subheading font-weight-light text-success text--darken-3"
                    >
                        {{ props.column.label }}
                    </span>
                </template>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'action'">
                        <a @click.stop="addMissing(props.row)" class=""
                            >Add Missing</a
                        >
                    </span>
                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>

                <template slot="expanded-row" slot-scope="props" class="pl-0">
                    <missing-boxes
                        class="pl-0 pt-0"
                        :route="props.row"
                        :distributionID="getDistributionID()"
                        :createBoxes="createBoxesForSelectedFamilies"
                    ></missing-boxes>
                </template>
            </vue-good-table>
        </v-card>
        <v-dialog persistent v-model="createBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Boxes</v-card-title
                >
                <v-layout align-center justify-center>
                    <v-card-actions>
                        <v-btn-toggle
                            mandatory
                            v-model="createBoxes.mode"
                            class="mb-2 elevation-0 button-toggle-override"
                            @change=""
                        >
                            <v-btn flat value="single" class="big-button">
                                Single Route
                            </v-btn>
                            <v-divider
                                vertical
                                style="border-color: #9e9e9e; margin-left: 0px !important; margin-right: 0px !important;"
                            ></v-divider>
                            <v-btn flat value="all" class="big-button">
                                All Routes
                            </v-btn>
                        </v-btn-toggle>
                    </v-card-actions>
                </v-layout>
                <div v-if="createBoxes.selected.length" class="text-info mb-3">
                    {{ createBoxes.selected.length }} Selected Families
                </div>
                <v-select
                    class="mb-0 mx-1"
                    label="Distribution"
                    ref="distribution"
                    :items="distributions.map((d) => d.distributionName)"
                    :rules="[rules.required]"
                    v-model="createBoxes.distributionName"
                ></v-select>
                <div
                    style="height: 300px; overflow-y: auto;"
                    v-if="createBoxes.mode == 'all'"
                >
                    <v-layout
                        row
                        class=""
                        v-for="(route, index) in createBoxes.routes"
                    >
                        <v-text-field
                            class="mb-0 mx-1"
                            label="Route"
                            disabled
                            style="width: 100px"
                            :rules="[rules.required]"
                            v-model="route.route"
                        ></v-text-field>
                        <v-text-field
                            class="mb-0 mx-1"
                            label="Truck"
                            :rules="[rules.required]"
                            v-model="route.truck"
                        ></v-text-field>
                        <v-menu
                            v-model="route.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mb-4 mx-1"
                                    hide-details
                                    v-model="route.deliveryDate"
                                    :value="route.deliveryDate"
                                    label="Delivery Date"
                                    prepend-icon="mdi-calendar"
                                    ref="deliveryDate"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="route.deliveryDate"
                                :min="today"
                            ></v-date-picker>
                        </v-menu>
                    </v-layout>
                </div>
                <div v-else>
                    <!-- <v-select
                        v-if="!createBoxes.allMissing"
                        class="mb-0 mx-1"
                        label="Routes"
                        ref="route"
                        :items="routes"
                        v-model="createBoxes.route"
                    ></v-select>
                    <v-text-field
                        class="mb-0 mx-1"
                        label="Truck"
                        v-model="createBoxes.truck"
                    ></v-text-field> -->
                    <v-menu
                        v-model="createBoxes.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="mb-4 mx-1"
                                hide-details
                                v-model="createBoxes.deliveryDate"
                                :value="createBoxes.deliveryDate"
                                label="Delivery Date"
                                prepend-icon="mdi-calendar"
                                ref="deliveryDate"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="createBoxes.deliveryDate"
                            :min="today"
                        ></v-date-picker>
                    </v-menu>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="createBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="create"
                    >
                        Create Boxes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="crossStreetUpdate.processingMessagesSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ crossStreetUpdate.processingMessages }}
                </div>
            </v-layout>
            <v-icon
                size="16"
                @click="crossStreetUpdate.processingMessagesSnackbar = false"
            >
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div></template
>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";
import XLSX from "xlsx";
import Pusher from "pusher-js";
import missingBoxes from "../components/MissingBoxes.vue";

export default {
    components: {
        missingBoxes,
    },
    data: () => ({
        title: "Routes",

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        actions: [],
        processing: false,

        selectedDistribution: "",
        url: "",

        distributions: [],
        routes: [],

        loadingMissing: true,

        createBoxesDialog: false,
        snackbarTimeout: 0,

        createBoxes: {
            datePickerMenu: false,
            route: "",
            distributionName: "",
            truck: "",
            deliveryDate: "",
            selected: [],
            allMissing: false,
            mode: "single",
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },

        missingBoxes: [],

        columns: [
            {
                label: "Route",
                field: "route",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Distribution Name",
                field: "distributionName",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scheduled Delivery Date",
                field: "scheduledDeliveryDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boxes Created Date",
                field: "boxesCreatedDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Families",
                field: "families",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boxes",
                field: "boxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Delivered",
                field: "delivered",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "UnDelivered",
                field: "unDelivered",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scanned Boxes",
                field: "scannedBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "UnScanned Boxes",
                field: "unScannedBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Large Boxes",
                field: "largeBoxes",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Small Boxes",
                field: "smallBoxes",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Scan Date",
                field: "lastScanDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "distributionStartDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        missingBoxesColumns: [
            {
                sortable: false,
                label: "Route",
                field: "route",
                hidden: false,
            },
            {
                sortable: false,
                label: "Missing",
                field: "missing",
                hidden: false,
            },
            {
                sortable: false,
                label: "Action",
                field: "action",
                width: "200px",
                hidden: false,
            },
        ],

        crossStreetUpdate: {
            requestID: "",
            processingMessagesSnackbar: false,
            processingMessages: "",
            totalProcessingMessages: "",
        },
    }),
    async created() {
        this.missingBoxesColumns.find(
            (c) => c.field == "action"
        ).linkAction = this.addMissing;
    },
    mounted() {
        this.subscribeToPusher();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("food-distribution");
    },
    methods: {
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("food-distribution");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("cross-street-update", (message) => {
                this.updateProcessingNotifications(message);
            });
        },
        updateProcessingNotifications(message) {
            if (message.requestID != this.crossStreetUpdate.requestID) return;

            if (
                message.index == this.crossStreetUpdate.totalProcessingMessages
            ) {
                this.crossStreetUpdate.processingMessages = "";
                this.crossStreetUpdate.processingMessagesSnackbar = false;
            } else {
                this.crossStreetUpdate.processingMessages =
                    message.index +
                    "/" +
                    this.crossStreetUpdate.totalProcessingMessages +
                    " " +
                    message.text;
            }
        },
        async beforeSetupGrid() {
            await this.loadDistributions();
            await this.loadRoutes();

            this.actions.push({
                text: "Import Cross Street",
                action: this.importCrossStreet,
                name: "importCrossStreet",
            });

            this.actions.push({
                text: "Export Grouped By Address",
                action: this.exportGroupedByAddress,
                name: "exportGroupedByAddress",
            });

            this.actions.push({
                text: "Create Boxes",
                action: this.openCreateBoxesDialog,
            });

            this.selectedDistribution = this.getSavedDistribution()
                ? this.getSavedDistribution()
                : this.distributions[this.distributions.length - 1]
                      .distributionName;

            localStorage.setItem(
                "SelectedDistribution",
                this.selectedDistribution
            );

            this.actions.push({
                text: "Select Distribution",
                align: "left",
                type: "select",
                values: this.distributions.map((d) => d.distributionName),
                value: this.selectedDistribution,
                onSelected: this.onDistributionSelected,
            });

            const distributionID = this.distributions.find(
                (d) => d.distributionName == this.selectedDistribution
            ).distributionID;

            this.createBoxes.distributionName = this.selectedDistribution;

            this.url =
                "foodDistributionRoutes?distributionID=" + distributionID;

            this.loadMissingBoxes(distributionID);
            this.loadTotalBoxesCount();
        },
        getDistributionID() {
            return this.distributions.find(
                (d) => d.distributionName == this.selectedDistribution
            ).distributionID;
        },
        async loadTotalBoxesCount() {
            const distributionID = this.getDistributionID();

            const response = await this.$http.get(
                "api/foodDistributionBoxes/getTotalBoxesCount?distributionID=" +
                    distributionID
            );

            this.crossStreetUpdate.totalProcessingMessages = response;
        },
        async exportGroupedByAddress() {
            try {
                const response = await this.$http({
                    url:
                        "api/foodDistributionAccountInfo/exportGroupedByAddress?distributionID=" +
                        this.getDistributionID(),
                    method: "GET",
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Boxes.xlsx");
                document.body.appendChild(link);
                link.click();
            } catch (e) {
            } finally {
            }
        },
        getSavedDistribution() {
            const saved = localStorage.getItem("SelectedDistribution");

            return saved &&
                this.distributions.find((d) => d.distributionName == saved)
                ? saved
                : "";
        },
        async onDistributionSelected(value) {
            const distributionID = this.distributions.find(
                (d) => d.distributionName == value
            ).distributionID;

            this.selectedDistribution = value;

            localStorage.setItem(
                "SelectedDistribution",
                this.selectedDistribution
            );

            this.createBoxes.distributionName = this.selectedDistribution;

            this.url =
                "foodDistributionRoutes?distributionID=" + distributionID;

            this.$refs.grid.reloadDataSource(this.url);

            this.loadMissingBoxes(distributionID);
            this.loadTotalBoxesCount();
        },
        async loadDistributions() {
            let response = await this.$http.get(
                "odata/foodWeeklyDistributions?$filter=not (isCompleted eq true)"
            );

            if (!response.value || !response.value.length) {
                response = await this.$http.get(
                    "odata/foodWeeklyDistributions?$orderby=dateCreated desc"
                );
            }

            this.distributions = response.value;
        },
        async loadRoutes() {
            const routes = await this.$http.get(
                "api/foodDistributionRoutes/getRouteNames"
            );

            this.routes = routes.filter(Boolean);

            this.createBoxes.routes = this.routes.map((route) => {
                return {
                    route: route,
                    truck: "",
                    deliveryDate: "",
                    datePickerMenu: false,
                };
            });
        },
        async loadMissingBoxes(distributionID) {
            const missingBoxes = await this.$http.get(
                "api/foodDistributionRoutes/GetMissingBoxes?distributionID=" +
                    distributionID
            );

            this.loadingMissing = false;

            this.missingBoxes = missingBoxes.map((missing) => {
                missing.action = "Add Missing";

                return missing;
            });
        },
        createBoxesForSelectedFamilies(selected) {
            this.createBoxes.route = selected[0].routeNumber;
            this.createBoxes.distributionName = this.selectedDistribution;
            this.createBoxes.selected = selected;

            this.createBoxesDialog = true;
        },
        openCreateBoxesDialog() {
            this.createBoxesDialog = true;
        },
        addMissing(row) {
            this.createBoxes.allMissing = false;
            this.createBoxes.route = row.route;

            this.createBoxesDialog = true;
        },
        addAllMissing() {
            this.createBoxes.allMissing = true;

            this.createBoxesDialog = true;
        },
        onRowClicked(data, rowType, column) {
            if (rowType == "header" || rowType == "filter") return;

            const distributionID = this.distributions.find(
                (d) => d.distributionName == this.selectedDistribution
            ).distributionID;

            if (rowType == "totalFooter") {
                this.$router.push({
                    name: "FoodDistributionAllBoxes",
                    query: {
                        distributionID: distributionID,
                        filter: column.dataField,
                    },
                });
            } else {
                this.$router.push({
                    name: "FoodDistributionAllBoxes",
                    query: {
                        distributionID: distributionID,
                        filter: column.dataField,
                        route: data.route,
                        scheduledDeliveryDate: moment(
                            data.scheduledDeliveryDate
                        ).format("yyyy-MM-DDThh:mm:ss"),
                    },
                });
            }
        },
        onCellClicked(event) {
            this.onRowClicked(event.data, event.rowType, event.column);
        },
        async importCrossStreet() {
            try {
                this.processing = true;

                this.crossStreetUpdate.requestID = Math.floor(
                    Math.random() * 10000000
                );

                this.processingMessages =
                    "0/" + this.crossStreetUpdate.totalProcessingMessages;

                this.crossStreetUpdate.processingMessagesSnackbar = true;

                const distributionID = this.getDistributionID();

                const response = await this.$http.post(
                    "api/foodDistributionBoxes/importCrossStreet?distributionID=" +
                        distributionID +
                        "&requestID=" +
                        this.crossStreetUpdate.requestID
                );

                this.processing = false;

                this.crossStreetUpdate.processingMessagesSnackbar = false;

                this.$notify({
                    group: "notification",
                    text: "Cross Street Updated",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        validate() {
            const validations = [this.$refs.distribution.validate(true)];

            return validations.every(Boolean);
        },
        async createCreateBoxesRequest() {
            const distributionID = this.distributions.find(
                (d) => d.distributionName == this.createBoxes.distributionName
            ).distributionID;

            if (this.createBoxes.mode == "single") {
                return await this.$http.post(
                    "api/foodDistributionRoutes/createBoxes",
                    {
                        // route: this.createBoxes.allMissing
                        //     ? ""
                        //     : this.createBoxes.route,
                        distributionID: distributionID,
                        deliveryDate: this.createBoxes.deliveryDate,
                        //truck: this.createBoxes.truck,
                        selectedIDs: this.createBoxes.selected.map(
                            (s) => s.familyID
                        ),
                    }
                );
            }

            return await this.$http.post(
                "api/foodDistributionRoutes/createBoxesForRoutes",
                this.createBoxes.routes.map((route) => ({
                    route: route.route,
                    distributionID: distributionID,
                    deliveryDate: route.deliveryDate,
                    truck: route.truck,
                    selectedIDs: [],
                }))
            );
        },
        async create() {
            if (!this.validate()) return;

            if (
                this.createBoxes.mode == "single" &&
                !this.createBoxes.deliveryDate
            ) {
                this.$notify({
                    group: "notification",
                    text: "Missing Delivery Date",
                    type: "error",
                });

                return;
            }

            if (
                this.createBoxes.mode == "all" &&
                this.createBoxes.routes.some((r) => !r.deliveryDate)
            ) {
                this.$notify({
                    group: "notification",
                    text: "Missing Delivery Date",
                    type: "error",
                });

                return;
            }

            try {
                this.processing = true;

                const response = await this.createCreateBoxesRequest();

                this.processing = false;
                this.createBoxesDialog = false;

                if (response.boxesCreated) {
                    this.$notify({
                        group: "notification",
                        text: response.boxesCreated + " Boxes Created",
                        type: "success",
                    });

                    this.$refs.grid.reloadGrid();

                    this.loadingMissing = true;

                    this.loadMissingBoxes();
                } else {
                    this.$notify({
                        group: "notification",
                        text: "This route already has all boxes created",
                        type: "error",
                    });
                }

                this.createBoxes.route = "";
                this.createBoxes.deliveryDate = "";
                this.createBoxes.truck = "";
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.missing-boxes-list .vgt-table {
    border: 1px solid #ddd !important;
}
.routes.container {
    padding-bottom: 0px !important;
}
.big-button {
    padding: 0 10px !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px !important;
}
.big-button .v-btn__content {
    padding: 0 10px !important;
    line-height: 48px;
}
.button-toggle-override {
    border-radius: 5px;
    overflow: hidden;
}
.button-toggle-override.v-btn-toggle .v-btn:not(:last-child) {
    border: none !important;
}
.button-toggle-override.v-btn-toggle .v-btn.v-btn--active {
    font-weight: 500 !important;
    background-color: #4caf50 !important;
    color: #fff;
}
.button-toggle-override.theme--light.v-btn-toggle .v-btn {
    background-color: #a8e8a4;
    opacity: 1;
    color: #fff;
    font-weight: 500 !important;
}
.reduce-margin .v-input__slot {
    margin-bottom: 0;
}
</style>
